"use strict";

require("core-js/modules/es.promise");

module.exports = (a, f) => a instanceof Promise ? a.then(f) : f(a);